import React from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";

class Doremi extends React.Component {
  /*Scroll to top of page at init*/
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>
            RPGONE Translations - DoReMi Fantasy : Milon's Quest - English
            Translation v1.3 SNES - ドレミファンタジー ミロンのドキドキ大冒険 -
            Do-Re-Mi Fantasy
          </title>
          <meta
            name="title"
            content="RPGONE Translations - DoReMi Fantasy : Milon's Quest - English Translation v1.3 SNES - ドレミファンタジー ミロンのドキドキ大冒険 - Do-Re-Mi Fantasy"
          />
          <meta
            name="description"
            content="Snes English Translation v1.3 - One day in Piccolo village, fairy Alis brings the terrible news to villagers that music has disappeared from the forest! Then suddenly, the demon Amon appears, kidnaps Alis and vanishes with her!! - DoReMi Fantasy : Milon's Quest for the SNES / Super Famicom / Super Nintendo by RPGONE Translations - Do-Re-Mi Fantasy"
          />
        </Helmet>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <span className="title-centered">
                {/*<h3>DoReMi Fantasy : Milon's Quest - English Translation</h3>
            <i><div>ドレミファンタジー ミロンのドキドキ大冒険</div></i>*/}
              </span>
              <div className="center-image">
                <img
                  src={require("./img/doremi00002_title.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/doremi_00053.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/doremi_00040.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/doremi_00232.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/doremi_00245.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/doremi_00202.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/doremi_00188.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/doremi_00174.png")}
                  alt=""
                  className="imageResize"
                />
                <br />
                <br />
                <i>
                  <div>
                    DoReMi Fantasy : Milon's Quest<br />Original release: 22nd
                    March 1996 on Super Famicom (Snes / Super Nintendo)
                  </div>
                </i>
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>Story</div>
              </b>
              <br />
              One day in Piccolo village, fairy Alis brings the terrible news to
              villagers that music has disappeared from the forest! Then
              suddenly, the demon Amon appears, kidnaps Alis and vanishes with
              her!!<br />
              <br />
              And so Milon, with his bubble shooter gun as his only weapon,
              embarks on a journey to rescue his kidnapped friend. Along the
              way, he'll need to retrieve the five stolen musical instruments by
              defeating Amon's strongest minions. Only Milon can save Alis and
              bring music back to Piccolo forest!
              <br />
              <br />
              <div className="center-image">
                <a
                  href={require("./img/box/Doremi Fantasy - Milons Quest - Box Cover.jpg")}
                >
                  <img
                    src={require("./img/box/Doremi Fantasy - Milons Quest - Box Cover.jpg")}
                    alt=""
                    className="imageResize imageSizing350"
                  />
                </a>{" "}
                <a
                  href={require("./img/box/Doremi Fantasy - Milons Quest - Box Back.jpg")}
                >
                  <img
                    src={require("./img/box/Doremi Fantasy - Milons Quest - Box Back.jpg")}
                    alt=""
                    className="imageResize imageSizing350"
                  />
                </a>
                <img
                  src={require("./img/proj/fantasia.jpg")}
                  alt=""
                  className="imageResize"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>Downloads</div>
              </b>
              <br />
              <a
                href={require("./files/Doremi Fantasy - English v1.3.zip")}
                download="Doremi Fantasy - English v1.3.zip"
              >
                English Translation patch v1.3
              </a>{" "}
              by RPGONE with new ending!
              <br />
              <br />
              <a href="http://www.romhacking.net/translations/1187/">
                German Translation patch v1.3
              </a>{" "}
              by Ghettoyouth with new ending!
              <br />
              <br />
              <a href="http://elbauldekarlanga.blogspot.com/2015/03/do-re-mi-fantasy-snes-espanol.html">
                Spanish Translation patch v1.2
              </a>{" "}
              by Crimental
              <br />
              <br />
              <a href="http://www.romhacking.net/translations/1192/">
                Project page on romhacking.net
              </a>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>PAR Codes</div>
              </b>
              <br />
              <b>7E0E5B02</b> - Green (3rd) Suit<br />
              <b>7E00F299</b> - 99 Musical Notes<br />
              <b>7E00F301</b> - Candy<br />
              <b>7E00F303</b> - Maze Key, Crystal<br />
              <b>7E00F308</b> - Boots<br />
              <b>7E046801</b> - Range Boost<br />
              <b>7E00F6FF</b> - All 5 Instruments<br />
              <b>7E00F5FF</b> - 5 Stars<br />
              <br />
              <code-container>
                <row-section>
                  <b>7E05EA</b>
                </row-section>
                <row-section>
                  <b>XX</b>
                </row-section>
                <row-section>- Mini Game Select</row-section>

                <row-section />
                <row-section-leftpadding>00</row-section-leftpadding>
                <row-section>- What was that?</row-section>

                <row-section />
                <row-section-leftpadding>01</row-section-leftpadding>
                <row-section>- Bird Hunter</row-section>

                <row-section />
                <row-section-leftpadding>02</row-section-leftpadding>
                <row-section>- How many birds?</row-section>
              </code-container>
              <br />
              <br />
              <b>7E00EE XX</b> - the Stage (0-7)<br />
              <b>7E00EF XX</b> - the Area (of the stage)<br />
              <br />
              <b>Debug Mode</b> (enter at title screen and press Start)<br />
              <code-container>
                <row-section>
                  <b>7E0030</b>
                </row-section>
                <row-section>0E</row-section>
                <row-section>- Visual Scene Viewer</row-section>

                <row-section />
                <row-section>0F</row-section>
                <row-section>- Level Objects Editor</row-section>

                <row-section />
                <row-section>10</row-section>
                <row-section>- Level Layout Viewer</row-section>
              </code-container>
              <br />
              <br />
              <b>Visual Debug</b>
              <br />
              05 - End of Stage 1<br />
              11 - End of Stage 2<br />
              17 - End of Stage 3<br />
              23 - End of Stage 4<br />
              31 - End of Stage 5<br />
              37 - End of Stage 6<br />
              <br />
              <b>Passwords</b>
              <br />
              0503 - Game Credits<br />
              4074 - Mini Game 1<br />
              0220 - Mini Game 2<br />
              1104 - Mini Game 3<br />
              2196 - World 1<br />
              1940 - World 2<br />
              3938 - World 3<br />
              5488 - World 4<br />
              0615 - World 5<br />
              6072 - World 6<br />
              0730 - World 7<br />
              7777 - Sound Test<br />
              2525 - Start with most Items<br />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Doremi);



// WEBPACK FOOTER //
// ./src/Doremi.js